import styled from "styled-components";
import { useState, useContext, useEffect } from "react";
import { ProgressSpinner } from "primereact/progressspinner";

const ProgressSpinnerBackground = styled.div`
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background-color: #ffffff52;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export default function SpinnerOverlay(props: Props) {
  return (
    <ProgressSpinnerBackground>
      <ProgressSpinner />
    </ProgressSpinnerBackground>
  );
}

interface Props {}
